<template>
    <div class="hotel">
        <!-- ficha hotel -->
        <!--------------------------------------------------------------------------- Grid -->
        <div class="card card-featured-hotel" v-if="vista=='G'">
            <img :src="imgUrl" class="card-img-top"/>
            <div class="card-body" style="min-height:190px;">
                <div class="days-price d-flex justify-content-between">
                    <div class="card-hotel-days">
                        <img :src="require('@/assets/css/img/calendar-icon.svg')" />
                        {{ item.dias }} días
                    </div>
                    <div class="sec-price d-flex flex-column align-items-end">
                        <div class="price">
                            <!-- <span class="price--desde pr-1">desde</span> -->
                            {{ item.precio }}
                            <span class="price--symbol">€</span>
                        </div>
                        <div class="card-price-small-text">por persona</div>
                    </div>
                </div>
                <div class="hotel-title pt-1 mb-0">{{ item.hotel }}</div>
                <!-- <div class="hotel-stars">
                    <img src="img/hotel-star-icon.svg" alt="" />
                    <img src="img/hotel-star-icon.svg" alt="" />
                    <img src="img/hotel-star-icon.svg" alt="" />
                </div> -->
                <div class="card-hotel-location text-primary">
                    <!-- <img :src="require('@/assets/css/img/map-marker-icon.svg')" />                         -->
                    <b-icon-geo-alt/>
                    <small> {{ item.pobla }} </small>
                </div>

                <!-- <div class="card-hotel-include mt-4">{{ item.info }}</div> -->

                <div class="text-center pt-2">
                    <b-btn variant="outline-secondary" class="mt-1 mr-1" size="xs"
                        @click="hotel_info(item)"
                        ><i class="fas fa-info-circle mr-1"></i>Info
                    </b-btn>
                    <b-btn variant="outline-secondary" class="mt-1" pill size="xs"
                        @click="hotel_precios(item)"
                        ><i class="fas fa-search mr-1"></i>Turnos
                    </b-btn>
                </div>
            </div>
        </div>

        <!---------------------------------------------------------------------------- Lista -->

        <div class="d-flex" v-else>
            <div class="card-hotel-info d-flex col-3">

                <div class="card-hotel-img ">
                    <!-- <img src="img/hotel-prince-park.jpg" alt="Hotel Prince Park" /> -->
                    <img :src="imgUrl" :alt="item.hotel"/>
                </div>
            </div>
            <div class="card-body col-9 d-flex flex-wrap">
                <div class="col-xs-12 col-md-8 mb-2">
                    <h5 class="hotel-title mb-0">{{ item.hotel }}</h5>
                    <!-- <div class="hotel-stars">
                        <img src="img/hotel-star-icon.svg" alt="" />
                        <img src="img/hotel-star-icon.svg" alt="" />
                        <img src="img/hotel-star-icon.svg" alt="" />
                    </div>                 -->
                    <div class="card-hotel-location">
                        <b-icon-geo-alt></b-icon-geo-alt>
                        {{ item.pobla }}
                    </div>
                    <div class="card-hotel-include mt-3">
                        <p class="font-weight-bold">El precio incluye</p>{{ item.info }}
                    </div>
                    <div class="pt-3">
                        <b-btn variant="outline-dark" class="mx-1" size="sm"
                            @click="hotel_info(item)"
                            ><i class="fas fa-info-circle mr-2"></i>Información
                        </b-btn>
                    </div>
                </div>
                <div class="price-days-booking col-xs-12 col-md-4 d-flex flex-column justify-content-between">
                    <div class="sec-price d-flex flex-column align-items-end">
                        <div class="price">
                            <span class="price--desde pr-1">desde</span>
                            {{ item.precio }}
                            <span class="price--symbol">€</span>
                        </div>
                        <div class="card-price-small-text">por personas</div>
                    </div>
                    <div class="card-hotel-days text-right mb-2">
                        <!-- <img src="/img/calendar-icon.svg" alt=""/> -->
                        <img :src="require('@/assets/css/img/calendar-icon.svg')" />
                        {{ item.dias }} días
                    </div>
                    <!-- Precios / Turnos -->
                    <div class="text-center">
                        <b-btn variant="outline-dark" class="mx-1" size="sm"
                            @click="hotel_precios(item)"
                            ><i class="fas fa-search mr-0"></i>Turnos
                        </b-btn>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

//import { mapActions } from 'vuex';

export default {
    name: 'hotel',
    props: {
        item: Object,
        //vista: Number,
    },
    data() {
        return {


        }
    },

    mounted() {

    },

    computed: {
        hotel() {
            return this.item;
        },

        vista() {
            return this.$parent.vista;
        },

        imgUrl() {
            if (!this.hotel.imagen) return "";
            //return this.$store.getters.hotel_imagen("||" + this.item.hot);
            return (this.hotel.imagen[0] ? this.$store.state.G.urlTMP + this.hotel.imagen[0] : '');
        },
    },
    methods: {
        //...mapActions(['imagenUrl']),

        hotel_info(hotel) {
            console.log("*hotel.hotel_info",hotel);
            //alert('Informacion Hotel');
            this.$parent.hotel_info(hotel);
        },
        hotel_precios(hotel) {
            console.log("*hotel.preciosyturnos",hotel);
            this.$parent.hotel_precios(hotel);
        },

    },

}
</script>